import { CSSProperties, SVGProps } from 'react'
import Colors from 'modules/Colors'

interface InstagramFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const InstagramFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: InstagramFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_181_143)">
                <path
                    d="M10.0063 5.45C8.99376 5.84375 8.13751 6.36875 7.28126 7.225C6.42501 8.075 5.90001 8.9375 5.50626 9.94375C5.12501 10.9187 4.86876 12.0375 4.79376 13.675C4.71876 15.3125 4.70001 15.8375 4.70001 20.0125C4.70001 24.1875 4.71876 24.7125 4.79376 26.35C4.86876 27.9875 5.13126 29.1062 5.50626 30.0812C5.90001 31.0937 6.42501 31.95 7.28126 32.8062C8.13751 33.6625 8.99376 34.1875 10.0063 34.5812C10.9813 34.9625 12.1 35.2188 13.7375 35.2938C15.375 35.3688 15.9 35.3875 20.075 35.3875C24.25 35.3875 24.775 35.3688 26.4125 35.2938C28.05 35.2188 29.1688 34.9562 30.1438 34.5812C31.1563 34.1875 32.0125 33.6625 32.8688 32.8062C33.725 31.95 34.25 31.0937 34.6438 30.0812C35.025 29.1062 35.2813 27.9875 35.3563 26.35C35.4313 24.7125 35.45 24.1875 35.45 20.0125C35.45 15.8375 35.4313 15.3125 35.3563 13.675C35.2813 12.0375 35.0188 10.9187 34.6438 9.94375C34.25 8.9375 33.725 8.075 32.875 7.225C32.0188 6.36875 31.1625 5.84375 30.15 5.45C29.175 5.06875 28.0563 4.8125 26.4188 4.7375C24.7813 4.6625 24.2563 4.64375 20.0813 4.64375C15.9063 4.64375 15.3813 4.6625 13.7438 4.7375C12.1 4.80625 10.9813 5.06875 10.0063 5.45ZM26.2875 7.5C27.7875 7.56875 28.6 7.81875 29.1438 8.03125C29.8625 8.3125 30.375 8.64375 30.9125 9.18125C31.45 9.71875 31.7813 10.2312 32.0625 10.95C32.275 11.4937 32.525 12.3062 32.5938 13.8062C32.6688 15.425 32.6813 15.9125 32.6813 20.0187C32.6813 24.125 32.6625 24.6125 32.5938 26.2313C32.525 27.7313 32.275 28.5437 32.0625 29.0875C31.7813 29.8062 31.45 30.3188 30.9125 30.8563C30.375 31.3938 29.8625 31.725 29.1438 32.0063C28.6 32.2188 27.7875 32.4688 26.2875 32.5375C24.6688 32.6125 24.1813 32.625 20.075 32.625C15.9688 32.625 15.4813 32.6063 13.8625 32.5375C12.3625 32.4688 11.55 32.2188 11.0063 32.0063C10.2875 31.725 9.77501 31.3938 9.23751 30.8563C8.70001 30.3188 8.36876 29.8062 8.08751 29.0875C7.87501 28.5437 7.62501 27.7313 7.55626 26.2313C7.48126 24.6125 7.46876 24.125 7.46876 20.0187C7.46876 15.9125 7.48751 15.425 7.55626 13.8062C7.62501 12.3062 7.87501 11.4937 8.08751 10.95C8.36876 10.2312 8.70001 9.71875 9.23751 9.18125C9.77501 8.64375 10.2875 8.3125 11.0063 8.03125C11.55 7.81875 12.3625 7.56875 13.8625 7.5C15.4813 7.425 15.9688 7.4125 20.075 7.4125C24.1813 7.4125 24.6688 7.425 26.2875 7.5Z"
                    fill={color}
                />
                <path
                    d="M12.1813 20.0187C12.1813 24.3812 15.7188 27.9125 20.075 27.9125C24.4313 27.9125 27.9688 24.375 27.9688 20.0187C27.9688 15.6625 24.4375 12.125 20.075 12.125C15.7125 12.125 12.1813 15.6562 12.1813 20.0187ZM25.2 20.0187C25.2 22.85 22.9063 25.1437 20.075 25.1437C17.2438 25.1437 14.95 22.85 14.95 20.0187C14.95 17.1875 17.2438 14.8938 20.075 14.8938C22.9063 14.8938 25.2 17.1875 25.2 20.0187Z"
                    fill={color}
                />
                <path
                    d="M28.2875 13.6562C29.3058 13.6562 30.1313 12.8308 30.1313 11.8125C30.1313 10.7942 29.3058 9.96875 28.2875 9.96875C27.2693 9.96875 26.4438 10.7942 26.4438 11.8125C26.4438 12.8308 27.2693 13.6562 28.2875 13.6562Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_181_143">
                    <rect width="32" height="32" fill="white" transform="translate(4 4)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default InstagramFlatIcon
